import { render, staticRenderFns } from "./api.vue?vue&type=template&id=3418e194&"
import script from "./api.vue?vue&type=script&lang=ts&"
export * from "./api.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports